//fetch
// export const baseUrl = "https://localhost:44365";
// export const baseUrl = "https://lisvdsewe.life.com.ec:4451";
export const baseUrl = "";
